// extracted by mini-css-extract-plugin
export var centerText = "_88-8";
export var container = "_88-0";
export var doughnutContainer = "_88-7";
export var legend = "_88-a";
export var legendItemColorDisplay = "_88-b";
export var legendItemLabel = "_88-d";
export var legendItemValue = "_88-c";
export var lg = "_88-5";
export var maxWidth = "_88-9";
export var md = "_88-4";
export var responsive = "_88-6";
export var sm = "_88-3";
export var xs = "_88-2";
export var xxs = "_88-1";